import axios from "axios";
import { notConnectedMessage } from "../../components/constants";
import { BASE_API } from "../../utils/constants";
import { Api_Response, Base_Filter, GET, POST } from "../base-services";
import { IBranch_Row } from "../branch/branch-service";
import { IOrganization_Row } from "../organization/organization-service";
import { IUser_Row } from "../user/user-service";

export class Attendance_Service {
    static url = `/attendance`;

    static async get_attendance(
        filter: Get_Attendance_Filter,
        api_key: string
    ) {
        const [data, error] = await GET<
            Get_Attendance_Response & { rows: IAttendance_Row | any[] }
        >(`${this.url}`, filter, {
            "x-org": filter.organizationCode,
            authorization: `Bearer ${api_key}`,
        });

        if (error) {
            return [data, error];
        }

        const expanded_rows = (data?.rows ?? [])
            .map((row) =>
                Object.values(row.checkInOutByDay).map((item) => {
                    const { checkInOutByDay, ...rest } = row;
                    return {
                        ...item,
                        ...rest,
                    };
                })
            )
            .flat();

        return [{ ...data, expanded_rows }, error];
    }

    static async get_attendanceByDay(
        { page = 1, limit = 10000, filter = {} },
        apiKey: string,
        orgCode: string
    ) {
        try {
            const response = await axios.get(
                `${BASE_API}` + `${this.url}/byDay`,
                {
                    withCredentials: true,
                    params: {
                        page,
                        limit,
                        ...filter,
                    },
                    headers: {
                        authorization: `Bearer ${apiKey}`,
                        "x-org": orgCode,
                    },
                }
            );
            return [response.data, null];
        } catch (err: any) {
            return [null, err?.response?.data?.message || notConnectedMessage];
        }
    }

    static async sync_branch_attendance(
        org_code: string,
        // api_key: string,
        branch_id: IBranch_Row["id"]
    ) {
        return POST<Sync_Branch_Attendance_Response>(
            `${this.url}/sync`,
            {},
            { branchId: branch_id },
            {
                "x-org": org_code,
                // authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async sync_device_attendance(
        sn: string,
        org_code: string,
        userPin?: string
        // api_key: string
    ) {
        return POST<Sync_Device_Attendance_Response>(
            `/user/sync/${sn}`,
            {},
            { userPin },
            {
                "x-org": org_code,
                // authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async sync_single_device_attendance(
        data: any,
        org_code: string,
        api_key: string
    ) {
        return POST<Sync_Device_Attendance_Response>(
            `${this.url}/sync-single-user-attendance`,
            { organizationCode: data.organizationCode, userId: data.userId },
            {},
            {
                "x-org": org_code,
                authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async get_absenties(
        filter: Get_Absenties_Filter & Base_Filter,
        org_code: string,
        api_key: string
    ) {
        const [data, error] = await GET<Get_Device_Absenties_Response>(
            `${this.url}/absenties`,
            filter,
            {
                "x-org": org_code,
                authorization: `Bearer ${api_key}`,
            }
        );

        if (error) {
            return [data, error];
        }

        // const rows = Object.entries(data ? data.absenteesByDate : {}).reduce(
        //     (prev: (Absentee_Row & { date: string })[], [date, absentees]) => {
        //         prev.push(...absentees.map((user) => ({ ...user, date })));

        //         return prev;
        //     },
        //     []
        // );

        return [
            {
                ...data,
                rows: Object.entries(data?.absenteesByDate ?? {}),
                // count: rows.length,
            },
            error,
        ];
    }
}

export type Get_Attendance_Filter = Base_Filter & {
    organizationCode: string;
    branchId?: number;
    startDate: string;
    endDate: string;
    user?: number;
    device?: string;
    apiKey?: string;
};

type Get_Attendance_Response = Api_Response<{
    success: boolean;
    message: string;
    count: number;
    rows: IAttendance_Row[];
}>;

export interface IAttendance_Row {
    user: {
        pin: number;
        name: string;
    };
    branch: {
        id: number;
        name: string;
    };
    organization: {
        name: string;
    };
    device: {
        serial: string;
    };
    checkInOutByDay: {
        [date: string]: {
            CheckIn: string | null;
            CheckOut: string | null;
            ids?: number[]; // New field for attendance IDs
        };
    };
}

type Sync_Device_Attendance_Response = Api_Response<{
    message: string;
}>;

type Sync_Branch_Attendance_Response = Api_Response<{
    message: string;
}>;

// type Get_Absenties_Filter = {
//     org_code: string;
//     api_key: string;
//     start_date: string;
//     end_date: string;
// };

export type Get_Absenties_Filter = {
    user?: number;
    branchId?: number;
    startDate?: string;
    endDate?: string;
    apiKey?: string;
};

export type Absentee_Row = IUser_Row & {
    branchId: IBranch_Row["id"];
    organizationCode: IOrganization_Row["code"];
};

type Get_Device_Absenties_Response = Api_Response<{
    success: boolean;
    message: string;
    absenteesByDate: {
        [date: string]: Absentee_Row[];
    };
}>;
